import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	forgetSuccessMsg: null,
	forgetError: null,
	changePasswordSuccessMsg: null,
	changePasswordError: null,
	createPasswordToken: null,
	isInvite: null,
	invitorUser: null,
	isAdmin: null,
	faf: null,
};

const forgotPasswordSlice = createSlice({
	name: "forgotpwd",
	initialState,
	reducers: {
		/* eslint-disable require-jsdoc */
		userForgetPasswordSuccess(state, action) {
			state.forgetSuccessMsg = action.payload;
		},
		userForgetPasswordError(state, action) {
			state.forgetError = action.payload;
		},
		userChangePasswordSuccess(state, action) {
			state.changePasswordSuccessMsg = action.payload;
		},
		userChangePasswordError(state, action) {
			state.changePasswordError = action.payload;
		},
		setCreatePassword(state, action) {
      state.createPasswordToken = action.payload.token;
      state.isInvite = Boolean(action.payload.isInvite);
      state.invitorUser = action.payload.invitorUser;
			state.isAdmin = Boolean(action.payload.isAdmin);
			state.faf = Boolean(action.payload.faf);
		}
		/* eslint-enable require-jsdoc */
	},
});

export const {
	userForgetPasswordSuccess,
	userForgetPasswordError,
	userChangePasswordSuccess,
	userChangePasswordError,
	setCreatePassword
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
